import React, { useEffect, useState } from 'react';
import { fetchAllRoutes } from 'services';
import { showError, sortArray } from 'utils';
import _ from 'lodash';

const RouteDropdown = props => {
  const [loading, setLoading] = useState<boolean>(true);
  const [routes, setRoutes] = useState<Record<string, any>[]>([]);
  const [routesForDropDown, setRoutesForDropDown] = useState<Record<string, any>[]>([]);
  const { disabled, selectedRoute, setRouteDetails, setSelectedRoute } = props;

  const fetchRoutes = async () => {
    try {
      const response = await fetchAllRoutes();
      const routes = response.map(row => {
        return {
          id: row.objectId,
          name: row.name,
        };
      });
      setRoutes(response);
      setRoutesForDropDown(routes);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoutes();
  }, []);
  
  const handleSelect = (routeId: string) => {
    setSelectedRoute(routeId, _.find(routes, ['objectId', routeId]));
    setRouteDetails && setRouteDetails(_.find(routes, ['objectId', routeId]));
  };

  const getRouteOptions = () => sortArray(routesForDropDown, 'name').map((route, i) => (
    <option key={i} value={route.id}>{route.name}</option>),
  );

  return (
    <select
      value={selectedRoute}
      disabled={loading || disabled}
      className='form-control'
      onChange={e => handleSelect(e.target.value)}
    >
      <option value='none' hidden={!!selectedRoute}>Select a Route</option>
      {routes.length && getRouteOptions()}
    </select>
  );
};

export default RouteDropdown;